






































import { defineComponent, PropType } from "@vue/composition-api";
import { getElement } from "@/lib/elementHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton/BaseIconButton.vue";
import BaseList, { BaseListItem } from "@/components/BaseList";

export default defineComponent({
  name: "BaseMenu",
  components: { BaseIconButton, BaseListItem, BaseList, BaseIcon },
  props: {
    activatorClass: { type: String, default: "" },
    items: { type: Array as () => BaseMenuItem[] | undefined },
    position: { type: String as PropType<"left" | "right" | "center">, default: "right" },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    hasItems(): boolean {
      return (this.items?.length ?? []) > 0;
    },
  },
  methods: {
    activator(e: Event) {
      e.stopPropagation();
      if (!this.show) {
        (getElement(this.$refs.activator) as HTMLElement).focus();
      }
      this.show = !this.show;
    },
    onFocusOut() {
      this.show = false;
    },
    onClick(item: BaseMenuItem) {
      this.$emit(`click:${item.name}`);
      this.$emit("click", item.name);
      this.show = false;
    },
  },
});
